module.exports = __webpack_public_path__ + "static/media/growth_icon.789ef445.png";